import { render, staticRenderFns } from "./IconSvgList.vue?vue&type=template&id=02106437&scoped=true&"
import script from "./IconSvgList.vue?vue&type=script&lang=js&"
export * from "./IconSvgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02106437",
  null
  
)

export default component.exports